<div class="form-step__subheading">
  Check your {{ selectedMultiFactorChallengeDevice$ | async }} for your security code. After you
  submit your code you will continue the check-in process.
</div>
<form class="typeform">
  <app-password-input
    data-private
    [dataTestId]="'enter-security-code'"
    [errorMessage]="errorMessage"
    [formControlRef]="securityCode"
    [inputmode]="'numeric'"
    [label]="'Security code'"
    >
  </app-password-input>
  <div class="error-valid-wrapper">
    @if (
      userCodeValidationState !== codeValidationStates.hide &&
      userCodeValidationState === codeValidationStates.invalid
      ) {
      <p
        class="error-hint"
        >
        Please wait {{ this.intervalTimer?.getRemainingSeconds() }} seconds before requesting another
        code.
      </p>
    }
    @if (
      userCodeValidationState !== codeValidationStates.hide &&
      userCodeValidationState === codeValidationStates.valid
      ) {
      <p
        class="valid-hint"
        >
        Code sent successfully.
      </p>
    }
  </div>

  <div class="buttons-container">
    <app-button
      class="verify-button"
      [dataTestId]="'verify-security-code'"
      type="primary"
      (click)="completeMultiFactorChallenge()"
      >
      Submit
    </app-button>
    <app-button
      class="resend-button"
      [dataTestId]="'resend-security-code'"
      type="secondary"
      (click)="resendMultiFactorChallenge()"
      >
      Resend Code
    </app-button>
    <app-button
      class="change-button"
      [dataTestId]="'change-security-method'"
      type="tertiary"
      (click)="resetMultiFactorChallengeSelection()"
      >
      Change how you receive code
    </app-button>
  </div>
</form>
